import { CREATE_MESSAGE, CREATE_GENERIC_ERROR_ALERT, CLEAR_ALERT, LOGOUT_SUCCESS} from "../actions/types";

const initialState = [
];

export default function (state = initialState, action) {
    switch (action.type) {
        case CREATE_GENERIC_ERROR_ALERT:
        case CREATE_MESSAGE:
            return [
                ...state,
                action.payload
            ]
        case LOGOUT_SUCCESS:
            return []
        case CLEAR_ALERT:
            return state.filter((message) => message.id !== action.payload)
        default:
            return state;
    }
}